import type { RouteRecordRaw } from "vue-router";
import { defineAsyncComponent } from "vue";

/**
 * Here is how a simple route is generated:
 * import { RouteRecordRaw } from 'vue-router'
 *
 * const routes: RouteRecordRaw = [{
 *    component: () => import('/src/pages/wizard-1.vue'),
 *    name: 'wizard-v1',
 *    path: '/wizard-v1',
 *    props: true,
 *    meta: {
 *      requiresAuth: true
 *    },
 * }]
 *
 * Here is how nested routes are generated:
 * import { RouteRecordRaw } from 'vue-router'
 *
 * const routes: RouteRecordRaw = [{
 *    component: () => import('/src/pages/auth.vue'),
 *    path: '/auth',
 *    props: true,
 *    children: [
 *      {
 *        component: () => import('/src/pages/auth/login-1.vue'),
 *        name: 'auth-login-1',
 *        path: 'login-1',
 *        props: true
 *      },
 *    ],
 * }]
 **/
/*
const permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];

function getNextAvailableRoute(currentRoute) {
  // Obtener todas las rutas definidas
  const allRoutes = router.options.routes;

  // Obtener el índice de la ruta actual
  const currentRouteIndex = allRoutes.findIndex(route => route.path === currentRoute.path);
  const childrenRoutes = allRoutes[currentRouteIndex]?.children;

  if (childrenRoutes && permissions) {
    // Buscar una ruta hija que cumpla con las condiciones de visualización
    for (let i = 0; i < childrenRoutes.length; i++) {
      const childRoute = childrenRoutes[i];
      for (let j = 0; j < permissions.length; j++) {
        const permission = permissions[j];
        if (
          (childRoute.meta?.viewCondition === permission.subject ||
            childRoute.meta?.viewCondition2 === permission.subject)
        ) {
          return childRoute; // Retorna la primera ruta que cumpla con las condiciones
        }
      }
    }
  }

  return null; // Retorna null si no se encuentra ninguna ruta disponible
}*/

const ___REDIRECT = JSON.parse(localStorage.getItem("auth"))?.profile?.mainApp;

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "default",
    redirect: {
      name:
        ___REDIRECT === "manager"
          ? "mDashboard"
          : ___REDIRECT === "operation"
          ? "operation-dashboard"
          : "dashboard",
    },
  },

  {
    path: "/",
    component: () => import("@/layouts/Auth/AuthLayout.vue"),
    meta: { requiredAuth: false },
    children: [
      {
        path: "privacy",
        name: "privacy",
        component: () =>
          import(
            "@/new_design/auth/components/policy/view/PrivacyPolicyMobile.vue"
          ),
        meta: { title: "Privacy policy" },
        props: true,
      },
      {
        path: "privacy_web",
        name: "privacy_web",
        component: () =>
          import("@/new_design/auth/components/policy/view/PrivacyPolicy.vue"),
        meta: { title: "Privacy policy" },
        props: true,
      },
      {
        path: "terms",
        name: "terms",
        component: () =>
          import("@/new_design/auth/components/terms/view/TermsViewMobile.vue"),
        meta: { title: "Terms and Conditions" },
        props: true,
      },
      {
        path: "terms_web",
        name: "terms_web",
        component: () =>
          import("@/new_design/auth/components/terms/view/TermsView.vue"),
        meta: { title: "Terms and Conditions" },
        props: true,
      },

      {
        path: "policy",
        name: "policy",
        component: () =>
          import(
            "@/new_design/auth/components/policy/view/PrivacyPolicyMobile.vue"
          ),
        meta: { title: "Privacy Policy" },
        props: true,
      },

      {
        path: "policy_web",
        name: "policy_web",
        component: () =>
          import("@/new_design/auth/components/policy/view/PrivacyPolicy.vue"),
        meta: { title: "Privacy Policy" },
        props: true,
      },
      {
        path: "contact",
        name: "contact",
        component: () =>
          import(
            "@/new_design/auth/components/contact/view/ContactUsViewMobile.vue"
          ),
        meta: { title: "Contact Us" },
        props: true,
      },
      {
        path: "contact_web",
        name: "contact_web",
        component: () =>
          import("@/new_design/auth/components/contact/view/ContactUsView.vue"),
        meta: { title: "Contact Us" },
        props: true,
      },
      //aqui poner el report
      {
        path: "report",
        name: "Report",
        component: () =>
          import("@/new_design/report/presentation/ReportView.vue"),
        meta: { requiredAuth: true, title: "Report" },
      },
      {
        path: "auth/login",
        name: "login",
        component: () =>
          import("@/new_design/auth/components/log_in/view/LoginView.vue"),
        meta: { title: "Login" },
        props: true,
      },
      // {
      //     path: "auth/register",
      //     name: "register",
      //     component: () => import("@/views/auth/RegisterView.vue"),
      //     meta: { title: 'Register' },
      // },
      {
        path: "/reset-password",
        name: "forgot_password",
        component: () =>
          import(
            "@/new_design/auth/components/forgot_pass/view/ForgotPasswordView.vue"
          ),
        meta: { title: "Forgot Password" },
      },

      {
        path: "/reset-password/send",
        name: "forgot_password_send",
        component: () =>
          import(
            "@/new_design/auth/components/forgot_pass/view/ForgotPasswordVerify.vue"
          ),
        meta: { title: "Forgot Password" },
      },
      {
        path: "/reset-password/verify",
        name: "forgot_password_verify",
        component: () =>
          import(
            "@/new_design/auth/components/change_password/presentation/view/ChangePasswordView.vue"
          ),
        meta: { title: "Change Password" },
      },
      {
        path: "/reset-password/success",
        name: "password_changed",
        component: () =>
          import(
            "@/new_design/auth/components/change_password/presentation/view/ChangePasswordSuccess.vue"
          ),
        meta: { title: "Password Changed" },
      },
    ],
  },
  {
    path: "/profile",
    name: "profile",
    component: defineAsyncComponent(
      () => import("@/new_design/profile/presentation/views/ProfileView.vue")
    ),
    meta: { requiredAuth: true, title: "Profile" },
  },
  {
    path: "/maintenance",
    component: () => import("@/new_design/layouts/appLayouts/AppLayout.vue"),
    meta: { requiredAuth: true, title: "Main" },
    children: [
      {
        path: "",
        name: "dashboard",
        component: defineAsyncComponent(
          () =>
            import(
              // "@/components/presentation/Dashboard/presentation/DashboardView.vue"
              "@/new_design/maintenance/dashboard/presentation/views/MaintenanceDashboardView.vue"
            )
        ),
        /*beforeEnter: (to, from, next) => {
            const hasPermission = permissions.some(
              element => element.subject === 'maintenanceDashboard'
            );
            if (hasPermission) {
              // Si tiene permiso, permitir el acceso a la ruta actual
              next();
            } else {
              // Si no tiene permiso, obtener la siguiente ruta disponible
              const nextRoute = getNextAvailableRoute(to);
              if (nextRoute !== null) {
                next(nextRoute);
              } else {
                next({ name: 'user' }); // Si no hay ruta disponible, redirigir a 'user'
              }
            }
          },*/
        meta: {
          title: "Dashboard",
          viewCondition: "maintenanceDashboard",
        },
      },
      {
        path: "planning",
        name: "planning",
        component: defineAsyncComponent(
          () =>
            import(
              // "@/components/presentation/Services/presentation/WorkOrderView.vue"
              "@/new_design/maintenance/workorders/presentation/views/WorkOrderView.vue"
            )
        ),
        /* beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'workOrder' || element.subject === 'issues')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          },*/
        meta: {
          title: "Work Orders",
          viewCondition: "workOrder",
          viewCondition2: "issues",
        },
      },
      {
        path: "site-inspection",
        name: "site-inspection",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/site_inspection/presentation/views/SiteInspectionView.vue"
            )
        ),
        /*beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'inspectOrder')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          },*/
        meta: {
          title: "Inspections",
          viewCondition: "inspectOrder",
        },
      },
      {
        path: "maintenance-statistics",
        name: "maintenance-statistics",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/statistics/presentation/views/StatisticsView.vue"
            )
        ),
        /*beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'inspectOrder')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          },*/
        meta: {
          title: "Maintenance Statistics",
          viewCondition: "Accounting",
        },
      },
      {
        path: "dot-annual-insp",
        name: "dot-annual-insp",
        component: defineAsyncComponent(
          () =>
            import(
              //"@/components/presentation/Inspections/InspectiosDotView.vue"
              "@/new_design/maintenance/dot/presentation/views/DotView.vue"
            )
        ),
        /* beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'inspectionsDot')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          },*/
        meta: {
          title: "DOT Anual Inspections",
          viewCondition: "inspectionsDot",
        },
      },
      {
        path: "PM-inspection",
        name: "pm",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/inspection_pm/presentation/views/InspectionPmView.vue"
            )
        ),
        /*   beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'inspectionPm')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          },*/
        meta: {
          title: "PM Inspection",
          viewCondition: "inspectionPm",
        },
      },
      {
        path: "monthly-inspection",
        name: "mon",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/monthly_inspection/presentation/views/MonthlyInspectionsView.vue"
            )
        ),
        /*    beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'inspections')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          }, */
        meta: {
          title: "Monthly Inspections",
          viewCondition: "inspections",
        },
      },
      {
        path: "services",
        name: "services",
        component: defineAsyncComponent(
          () =>
            /*import(
              "@/components/presentation/Services/presentation/ServicesView.vue"
            )*/
            import(
              "@/new_design/maintenance/service_task/presentation/views/ServiceTaskView.vue"
            )
        ),
        /*    beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'serviceTask')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          }, */
        meta: {
          title: "Services",
          viewCondition: "serviceTask",
        },
      },
      {
        path: "equipment",
        name: "equipments",
        component: defineAsyncComponent(
          () =>
            import(
              //"@/components/presentation/Equipments/presentation/EquipmentsView.vue"
              "@/new_design/maintenance/equipment/presentation/views/EquipmentView.vue"
            )
        ),
        /*    beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'equipment')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          }, */
        meta: {
          title: "Equipments",
          viewCondition: "equipment",
        },
      },
      {
        path: "parts",
        name: "parts",
        component: defineAsyncComponent(
          () =>
            import(
              "@/components/presentation/Inventory/presentation/InventoryView.vue"
            )
        ),
        /*   beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'parts' || element.subject === 'inventory-distribution')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          }, */
        meta: {
          title: "Parts & Inventory",
          viewCondition: "inventory-distribution",
          viewCondition2: "parts",
        },
      },
      {
        path: "part",
        name: "part",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/part/presentation/views/PartView.vue"
            )
        ),
        meta: {
          title: "Part",
          viewCondition: "parts",
        },
      },
      {
        path: "inventory",
        name: "inventory",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/inventory/presentation/views/InventoryView.vue"
            )
        ),
        /*   beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'parts' || element.subject === 'inventory-distribution')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          }, */
        meta: {
          title: "Inventory",
          viewCondition: "inventory-distribution",
          viewCondition2: "parts",
        },
      },
      {
        path: "forklift-inspection",
        name: "forklift-inspection",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/forklift_inspection/presentation/views/ForkliftInspectionView.vue"
              // "@/components/presentation/Inspections/presentation/FLInspectionView.vue"
            )
        ),
        /*     beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'inspectionFL')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          },*/
        meta: {
          title: "Forklift Inspection",
          viewCondition: "inspectionFL",
        },
      },
      {
        path: "provider",
        name: "provider",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/provider/presentation/views/ProviderView.vue"
            )
        ),
        /*   beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'inventory-purchase')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          }, */
        meta: {
          title: "Provider",
          viewCondition: "inventory-purchase",
        },
      },
      // {
      //   path: "locations",
      //   name: "locations",
      //   component: defineAsyncComponent(
      //     () =>
      //       import(
      //         "@/components/presentation/Locations/presentation/LocationsView.vue"
      //       )
      //   ),
      //   /*   beforeEnter: (to,from) => {
      //       permissions.forEach(element => {
      //         if(element.subject === 'maintenance-locations')  {
      //           return true
      //         } else {
      //           const nextRoute = getNextAvailableRoute(to)
      //           if(nextRoute !== null) {
      //             router.push(nextRoute)
      //           } else {
      //             router.push({name: 'user'})
      //             return false
      //           }
      //         }
      //       });
      //     }, */
      //   meta: {
      //     title: "Locations",
      //     viewCondition: "maintenance-locations",
      //   },
      // },
      {
        path: "warehouse",
        name: "Warehouse",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/warehouse/presentation/views/WarehouseView.vue"
            )
        ),
        meta: {
          title: "Warehouse",
          viewCondition: "maintenance-locations",
        },
      },
      // {
      //   path: "accountability",
      //   name: "accountability",
      //   component: defineAsyncComponent(
      //     () =>
      //       import(
      //         "@/components/presentation/Accountability/presentation/AccountabilityView.vue"
      //       )
      //   ),
      //   /*    beforeEnter: (to,from) => {
      //       permissions.forEach(element => {
      //         if(element.subject === 'accounting')  {
      //           return true
      //         } else {
      //           const nextRoute = getNextAvailableRoute(to)
      //           if(nextRoute !== null) {
      //             router.push(nextRoute)
      //           } else {
      //             router.push({name: 'user'})
      //             return false
      //           }
      //         }
      //       });
      //     }, */
      //   meta: {
      //     title: "Accountability",
      //     viewCondition: "Accounting",
      //   },
      // },
      {
        path: "accounting",
        name: "accounting",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/accounting/presentation/views/AccountingView.vue"
            )
        ),
        meta: {
          title: "Accounting",
          viewCondition: "Accounting",
        },
      },
      {
        path: "documents",
        name: "documents",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/maintenance/documents/presentation/views/DocumentView.vue"
              // "@/components/presentation/Documents/presentation/DocumentsView.vue"
            )
        ),
        /*   beforeEnter: (to,from) => {
            permissions.forEach(element => {
              if(element.subject === 'accounting')  {
                return true
              } else {
                const nextRoute = getNextAvailableRoute(to)
                if(nextRoute !== null) {
                  router.push(nextRoute)
                } else {
                  router.push({name: 'user'})
                  return false
                }           
              }
            });
          }, */
        meta: {
          title: "Documents",
          viewCondition: "accounting",
        },
      },

      /*{
        path: "issues",
        name: "issues",
        component: () =>
          import(
            "@/components/presentation/Issues/presentation/IssuesView.vue"
          ),
        meta: {
          title: "Issues",
          viewCondition: "issues",
        },
      },
      
      
      
      
      
      
      
      {
        path: "test",
        name: "test",
        component: () => import("@/components/presentation/Test/TestView.vue"),
        meta: {
          title: "Test",
        },
      },*/
    ],
  },
  {
    path: "/operation",
    component: () => import("@/new_design/layouts/appLayouts/AppLayout.vue"),
    meta: { requiredAuth: true, title: "Operation" },
    children: [
      {
        path: "load",
        name: "Bulk",
        component: () =>
          import(
            "@/new_design/operations/loads/presentation/views/LoadsView.vue"
          ),

        meta: {
          title: "Bulk",
          viewCondition: "charge",
        },
      } /*
       {
         path: "load",
         name: "Bulk",
         component: defineAsyncComponent(
           () => import("../views/load/LoadView.vue")
         ),

         meta: {
           title: "Bulk",
           viewCondition: "charge",
         },
       },*/,
      {
        path: "load-liquid-bulk",
        name: "Liquid Bulk",
        component: () =>
          import(
            "@/new_design/operations/loads/presentation/views/LoadsView.vue"
          ),

        meta: {
          title: "Liquid Bulk",
          viewCondition: "charge",
        },
      },
      {
        path: "load-aggregate",
        name: "Aggregate",
        component: () =>
          import(
            "@/new_design/operations/loads/presentation/views/LoadsView.vue"
          ),

        meta: {
          title: "Aggregate",
          viewCondition: "charge",
        },
      },
      {
        path: "load-tmf",
        name: "TMF",
        component: () =>
          import(
            "@/new_design/operations/loads/presentation/views/LoadsView.vue"
          ),
        meta: {
          title: "TMF",
          viewCondition: "charge",
        },
      },
      {
        path: "load-walking-floor",
        name: "Walking Floor",
        component: () =>
          import(
            "@/new_design/operations/loads/presentation/views/LoadsView.vue"
          ),
        meta: {
          title: "Walking Floor",
          viewCondition: "charge",
        },
      },

      {
        path: "precast",
        name: "Precast",
        component: () =>
          import(
            "@/new_design/operations/loads/presentation/views/LoadsView.vue"
          ),
        meta: {
          title: "Precast",
          viewCondition: "precast-project",
          viewCondition2: "charge",
        },
      },
      // {
      //   path: "precast-project",
      //   name: "Precast Project",
      //   component: defineAsyncComponent(
      //     () => import("../views/precast/PrecastView.vue")
      //   ),
      //   meta: {
      //     title: "Precast Project",
      //     viewCondition: "precast-project",
      //     viewCondition2: "charge",
      //   },
      // },
      {
        path: "",
        name: "operation-dashboard",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/operations/dashboard/presentation/OpperationsDashboardView.vue"
            )
        ),
        //component: () => import("@/components/presentation/Operation/Dashboard/OperationDashboardView.vue"),
        meta: {
          title: "OperationDashboard",
          viewCondition: "chargeDashboard",
        },
      },
      {
        path: "olocations",
        name: "olocations",
        component: defineAsyncComponent(
          () => import("../views/locations/Locations.vue")
        ),
      },
      /*{
        path: "fleettypes",
        name: "Fleet Types",
        component: () => import("../views/fleet-types/FleetTypes.vue"),
      },*/
      {
        path: "chargetypes/:fleetTypeId?",
        name: "charge Types",
        component: defineAsyncComponent(
          () => import("../views/charge-types/ChargeTypes.vue")
        ),
      },
      {
        path: "statistics",
        name: "statistics",
        meta: {
          title: "Statistics",
        },
        component: defineAsyncComponent(
          // () => import("../views/statistics/StatisticsView.vue")
          () =>
            import(
              "@/new_design/operations/statistics/presentation/views/StatisticsView.vue"
            )
        ),
      },
      {
        path: "documents",
        name: "operation_documents",
        //component: () => import("../views/documents/DocumentsView.vue"),
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/operations/documents/presentation/views/DocumentsView.vue"
            )
        ),
        meta: {
          title: "OperationDocuments",
          viewCondition: "charge",
        },
      },
      {
        path: "support-tickets",
        name: "support-tickets",
        //component: () => import("../views/documents/DocumentsView.vue"),
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/operations/support_tickets/presentation/views/ReportTicketsView.vue"
            )
        ),
        meta: {
          title: "Support Tickets",
          viewCondition: "charge",
        },
      },
      {
        path: "test",
        name: "test",
        component: defineAsyncComponent(
          () =>
            import(
              "../components/load/components/DuplicatedTicketsLoads/DuplicatedTicketsTable.vue"
            )
        ),
      },
      {
        path: "map",
        name: "map",
        redirect: { name: "map_axis" },
        children: [
          {
            path: "axis",
            name: "map_axis",
            component: defineAsyncComponent(
              () => import("@/views/map/MapAxisView.vue")
            ),
          },
          {
            path: "samsara",
            name: "map_samsara",
            redirect: { name: "map_samsara_all" },
            children: [
              {
                path: "all",
                name: "map_samsara_all",
                component: defineAsyncComponent(
                  () => import("@/views/map/MapSamsaraFull.vue")
                ),
              },
              {
                path: "routes",
                name: "map_samsara_routes",
                component: defineAsyncComponent(
                  () => import("@/views/map/MapAxisViewAssigned.vue")
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/loading",
    name: "loading",
    component: defineAsyncComponent(
      () => import("@/new_design/components/ui/loading/RiveLoading.vue")
    ),
  },
  {
    path: "/nonav",
    name: "nonav",
    component: () => import("@/components/ui/NoNav.vue"),
  },
  {
    path: "/manager",
    component: () => import("@/new_design/layouts/appLayouts/AppLayout.vue"),
    meta: { requiredAuth: true, title: "Manager" },
    children: [
      {
        path: "administrator",
        name: "administrator",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/administrator/presentation/views/AdministratorView.vue"
            )
        ),
        meta: {
          title: "Administrator",
          viewCondition: "companyUsers",
        },
      },
      {
        path: "manager",
        name: "manager",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/manager/presentation/views/ManagerView.vue"
            )
        ),
        meta: {
          title: "Manager",
          viewCondition: "companyUsers",
        },
      },
      {
        path: "employee",
        name: "employee",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/employee/presentation/views/EmployeeView.vue"
            )
        ),
        meta: {
          title: "Employee",
          viewCondition: "user",
        },
      },
      {
        path: "dispatcher",
        name: "dispatcher",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/dispatcher/presentation/views/DispatcherView.vue"
            )
        ),
        meta: {
          title: "Dispatcher",
          viewCondition: "companyUsers",
        },
      },

      {
        path: "technician",
        name: "technician",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/technician/presentation/views/TechnicianView.vue"
            )
        ),
        meta: {
          title: "Technician",
          viewCondition: "user",
        },
      },
      {
        path: "driver",
        name: "driver",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/driver/presentation/views/DriverView.vue"
            )
        ),
        meta: {
          title: "Driver",
        },
      },
      {
        path: "customer",
        name: "customer",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/customer/presentation/view/CustomerView.vue"
            )
        ),
        meta: {
          title: "Customer",
          viewCondition: "customers",
        },
      },
      {
        path: "rates",
        name: "rates-od",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/rates/presentation/components/views/RateVIew.vue"
            )
        ),
        meta: {
          title: "Rates",
          viewCondition: "customers",
        },
      },
      {
        path: "location",
        name: "location",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/location/presentation/views/LocationView.vue"
            )
        ),
        meta: {
          title: "Location",
          viewCondition: "charge-location",
        },
      },
      {
        path: "vehicle",
        name: "vehicle",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/vehicle/presentation/views/VehicleView.vue"
            )
        ),
        meta: {
          title: "Vehicle",
          viewCondition: "vehicle",
        },
      },
      {
        path: "trailer",
        name: "trailer",
        component: defineAsyncComponent(
          () =>
            import(
              "@/new_design/manager/trailer/presentation/views/TrailerView.vue"
            )
        ),
        meta: {
          title: "Trailer",
          viewCondition: "driver",
        },
      },
      {
        path: "",
        name: "mDashboard",
        component: defineAsyncComponent(
          () => import("@/new_design/manager/views/dashboard/DashboardView.vue")
        ),
      },
      {
        path: "company_rates/client/:customer_id",
        name: "Client Rates",
        component: defineAsyncComponent(
          () =>
            import(
              "@/components/presentation/Manager/Rates/presentation/ClientRatesView.vue"
            )
        ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "company_rates/client/:customer_id/rate/:rate_id",
        name: "Client Rate",
        component: defineAsyncComponent(
          () =>
            import(
              "@/components/presentation/Manager/Rates/presentation/CurrentClientRatesView.vue"
            )
        ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/manager/administrator/:id",
    name: "admin-details",
    component: () =>
      import(
        "@/new_design/manager/administrator/presentation/views/AdministratorDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/operations/document/:id",
    name: "operations-document-details",
    component: () =>
      import(
        "@/new_design/operations/documents/presentation/views/DocumentDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/operation/support-tickets/:ticketId",
    name: "support-tickets-details",
    meta: {
      title: "Support Tickets Details",
      viewCondition: "charge",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/operations/support_tickets/presentation/views/ReportTicketDetailsPage.vue"
      ),
  },
  {
    path: "/profile/support-tickets/:ticketId",
    name: "support-tickets-details-profile",
    meta: {
      title: "Support Tickets Details",
      viewCondition: "charge",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/operations/support_tickets/presentation/views/ReportTicketDetailsPage.vue"
      ),
  },
  {
    path: "/workorders/issue/:issueId",
    name: "issue-details",
    meta: {
      title: "Issue Details",
      viewCondition: "charge",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/workorders/presentation/views/IssueDetailsPage.vue"
      ),
  },
  {
    path: "/workorders/details/:workOrderId/:archived?",
    name: "work-order-details",
    meta: {
      title: "Work Order Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/workorders/presentation/views/WorkOrderDetailsPage.vue"
      ),
  },
  {
    path: "/pm/details/:id/:archived?",
    name: "inspectionpm-details",
    meta: {
      title: "Inspection Pm Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/inspection_pm/presentation/views/InspectionPmDetailsPage.vue"
      ),
  },
  {
    path: "/monthly-inspection/details/:id",
    name: "monthly-inspection-details",
    meta: {
      title: "Monthly Inspection Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/monthly_inspection/presentation/views/MonthlyInspectionDetailsPage.vue"
      ),
  },
  {
    path: "/monthly-inspection/details/:id/tractor/:service_name",
    name: "tractor-mon-details",
    meta: {
      title: "Tractor Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/monthly_inspection/presentation/components/table/TractorDetails.vue"
      ),
  },
  {
    path: "/workorders/service-task/:serviceTaskId",
    name: "service-task-details",
    meta: {
      title: "Service Task Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/workorders/presentation/components/service_tasks/ServiceTasks/presentation/ServiceTaskDetailsPage.vue"
      ),
  },
  {
    path: "/workorders/labor/:laborId",
    name: "labor-details",
    meta: {
      title: "Labor Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/presentation/Labors/presentation/LaborsDetailsPage.vue"
      ),
  },
  {
    path: "/workorders/part/:partId",
    name: "part-details",
    meta: {
      title: "Part Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/workorders/presentation/components/Parts/presentation/PartsDetailsPage.vue"
      ),
  },
  {
    path: "/manager/manager/:id",
    name: "manager-details",
    component: () =>
      import(
        "@/new_design/manager/manager/presentation/views/ManagerDetailsPage.vue"
      ),
  },
  {
    path: "/manager/dispatcher/:id",
    name: "dispatcher-details",
    component: () =>
      import(
        "@/new_design/manager/dispatcher/presentation/views/DispatcherDetailsPage.vue"
      ),
  },
  {
    path: "/manager/employee/:id",
    name: "employee-details",
    component: () =>
      import(
        "@/new_design/manager/employee/presentation/views/EmployeeDetailsPage.vue"
      ),
  },
  {
    path: "/manager/technician/:id",
    name: "technician-details",
    component: () =>
      import(
        "@/new_design/manager/technician/presentation/views/TechnicianDetailsPage.vue"
      ),
  },
  {
    path: "/manager/vehicle/:id",
    name: "vehicle-details",
    component: () =>
      import(
        "@/new_design/manager/vehicle/presentation/views/VehicleDetailsPage.vue"
      ),
  },
  {
    path: "/manager/driver/:id",
    name: "driver-details",
    component: () =>
      import(
        "@/new_design/manager/driver/presentation/views/DriverDetailsPage.vue"
      ),
  },
  {
    path: "/pm/labor/:id",
    name: "labor-pm-details",
    meta: {
      title: "Labor Details",
    },
    component: () =>
      import(
        "@/new_design/maintenance/inspection_pm/labors/presentation/LaborsDetailsPmPage.vue"
      ),
  },
  {
    path: "/manager/trailer-details/:id",
    name: "trailer-details",
    component: () =>
      import(
        "@/new_design/manager/trailer/presentation/views/TrailerDetailsPage.vue"
      ),
  },
  {
    path: "/manager/location-details/:id",
    name: "location-details",
    component: () =>
      import(
        "@/new_design/manager/location/presentation/views/LocationDetailsPage.vue"
      ),
  },
  {
    path: "/not-access",
    name: "not-access",
    component: () => import("@/new_design/manager/views/NotAccess.vue"),
  },
  {
    path: "/error/:error/:module/:fallbackRoute?",
    name: "error",
    component: () => import("@/new_design/manager/views/GeneralError.vue"),
    props: true,
  },
  {
    path: "/maintenance/warehouse/:id",
    name: "warehouse-details",
    component: () =>
      import(
        "@/new_design/maintenance/warehouse/presentation/views/WarehouseDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/service_task/:id",
    name: "serviceTask-details",
    component: () =>
      import(
        "@/new_design/maintenance/service_task/presentation/views/ServiceTaskDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
    // component: (
    //   () =>
    //     import(
    //       "../components/load/components/DuplicatedTicketsLoads/DuplicatedTicketsTable.vue"
    //     )
    // ),
  },
  {
    path: "/equipment/:id",
    name: "equipment-details",
    component: () =>
      import(
        "@/new_design/maintenance/equipment/presentation/views/EquipmentDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/maintenance/provider/:id",
    name: "provider-details",
    component: () =>
      import(
        "@/new_design/maintenance/provider/presentation/views/ProviderDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/dot/:id/:archived?",
    name: "dot-details",
    component: () =>
      import(
        "@/new_design/maintenance/dot/presentation/views/DotDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/maintenance/site-inspection/:id/:archived?",
    name: "site-inspection-details",
    component: () =>
      import(
        "@/new_design/maintenance/site_inspection/presentation/views/SiteInspectionDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/truck/:vehicle_id",
    name: "Truck Resume",
    component: defineAsyncComponent(
      () =>
        import(
          "@/new_design/manager/resume/presentation/views/VehicleResumeDetailPage.vue"
        )
    ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/trailer/:vehicle_id",
    name: "Trailer Resume",
    component: defineAsyncComponent(
      () =>
        import(
          "@/new_design/manager/resume/presentation/views/VehicleResumeDetailPage.vue"
        )
    ),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/maintenance/forklift-inspection/:id",
  //   name: "forklift-inspection-details",
  //   component: () =>
  //     import(
  //       "@/new_design/maintenance/forklift_inspection/presentation/views/ForkliftInspectionDetailsPage.vue"
  //     ),
  //   meta: { requiredAuth: true },
  // },
  // {
  //   path: "/maintenance/forklift-inspection/tractor-details/:id",
  //   name: "tractor-fork-details",
  //   component: () =>
  //     import(
  //       "@/new_design/maintenance/forklift_inspection/presentation/components/table/TractorDetails.vue"
  //     ),
  //   meta: { requiredAuth: true },
  // },
  {
    path: "/forklift-inspection/details/:id",
    name: "forklift-inspection-details",
    meta: {
      title: "Forklift Inspection Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/forklift_inspection/presentation/views/ForkliftInspectionDetailsPage.vue"
      ),
  },
  {
    path: "/forklift-inspection/details/:id/tractor/:service_name",
    name: "tractor-fork-details",
    meta: {
      title: "Tractor Details",
    },
    props: true,
    component: () =>
      import(
        "@/new_design/maintenance/forklift_inspection/presentation/components/table/TractorDetails.vue"
      ),
  },
  {
    path: "/part/:id",
    name: "part-only-details",
    component: () =>
      import(
        "@/new_design/maintenance/part/presentation/views/PartDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/part/adjustment/:id",
    name: "part-adjustemt",
    component: () =>
      import(
        "@/new_design/maintenance/part/presentation/views/PartAdjustPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/part/redistribution/:id",
    name: "part-redistribution",
    component: () =>
      import(
        "@/new_design/maintenance/part/presentation/views/PartRedistributionPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/part/:id",
    name: "part-only-details",
    component: () =>
      import(
        "@/new_design/maintenance/part/presentation/views/PartDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/purchase/:id",
    name: "purchase-details",
    component: () =>
      import(
        "@/new_design/maintenance/inventory/presentation/views/PurchaseDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/part/adjustment/:id",
    name: "part-adjustemt",
    component: () =>
      import(
        "@/new_design/maintenance/part/presentation/views/PartAdjustPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/purchase/redistribution/:id",
    name: "purchase-redistribution",
    component: () =>
      import(
        "@/new_design/maintenance/inventory/presentation/views/PartDistributionPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/adjustment/:id",
    name: "adjustment-details",
    component: () =>
      import(
        "@/new_design/maintenance/inventory/presentation/views/AdjustmentDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/part/redistribution/:id",
    name: "part-redistribution",
    component: () =>
      import(
        "@/new_design/maintenance/part/presentation/views/PartRedistributionPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/outofstock/:id",
    name: "outofstock-details",
    component: () =>
      import(
        "@/new_design/maintenance/inventory/presentation/views/OutOfStockDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/documents/:id",
    name: "document-details",
    component: () =>
      import(
        "@/new_design/maintenance/documents/presentation/views/DocumentDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/accounting/:id",
    name: "accounting-details",
    component: () =>
      import(
        "@/new_design/maintenance/accounting/presentation/views/AccountingDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/warehouse-part/:id/:location",
    name: "warehouse-part-details",
    component: () =>
      import(
        "@/new_design/maintenance/warehouse/presentation/views/PartDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/warehouse-part/redistribution/:id",
    name: "warehouse-part-redistribution",
    component: () =>
      import(
        "@/new_design/maintenance/warehouse/presentation/views/PartRedistributionPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/warehouse-part-adjustment/:id",
    name: "warehouse-part-adjustment",
    component: () =>
      import(
        "@/new_design/maintenance/warehouse/presentation/views/PartAdjustPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/warehouse-part-only-redistribution/:id",
    name: "warehouse-part-only-redistribution",
    component: () =>
      import(
        "@/new_design/maintenance/warehouse/presentation/views/PartRedistributionOnlyPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/maintenance/expenses/:company/:startDate/:endDate",
    name: "maintenance-expenses",
    component: () =>
      import(
        "@/new_design/maintenance/dashboard/presentation/views/ExpensesDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/maintenance/issues-by-location/:company/:startDate/:endDate",
    name: "maintenance-issues-by-location",
    component: () =>
      import(
        "@/new_design/maintenance/dashboard/presentation/views/DashboardIssueDetailsLocationPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/maintenance/issues-by-categories/:company/:startDate/:endDate",
    name: "maintenance-issues-by-categories",
    component: () =>
      import(
        "@/new_design/maintenance/dashboard/presentation/views/DashboardIssueDetailsCategoryPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/maintenance/labors-technician/:company/:startDate/:endDate",
    name: "maintenance-labors-technician",
    component: () =>
      import(
        "@/new_design/maintenance/dashboard/presentation/views/DashboardLaborsDetailsTechnicianPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/maintenance/labors-technician-by-technician/:technicianId/:company/:startDate/:endDate",
    name: "maintenance-labors-technician-by-technician",
    component: () =>
      import(
        "@/new_design/maintenance/dashboard/presentation/views/DashboardLaborsDetailsFullTechnicianPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/maintenance/labors-vendor/:company/:startDate/:endDate",
    name: "maintenance-labors-vendor",
    component: () =>
      import(
        "@/new_design/maintenance/dashboard/presentation/views/DashboardLaborsDetailsVendorsPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/maintenance/work-order-technician/:company/:startDate/:endDate",
    name: "work-order-technician",
    component: () =>
      import(
        "@/new_design/maintenance/dashboard/presentation/views/DashboardWOrkOrdersDetailsTechnicianPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/maintenance/work-order-part/:company/:startDate/:endDate",
    name: "work-order-part",
    component: () =>
      import(
        "@/new_design/maintenance/dashboard/presentation/views/DashboardWOrkOrdersDetailsPartsPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },

  {
    path: "/customer/:id",
    name: "customer-details",
    component: () =>
      import(
        "@/new_design/manager/customer/presentation/view/CustomerDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/additional-charges/:id/:customer",
    name: "additional-charge-details",
    component: () =>
      import(
        "@/new_design/manager/additionalCharge/presentation/view/AdditionalChargeDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  //src\new_design\operations\loads\presentation\views\LoadsDetails\AdditionalChargeLoadDetailsPage.vue
  {
    path: "/additional-charges-charge/:code/:charge",
    name: "additional-charge-details-charge",
    component: () =>
      import(
        "@/new_design/operations/loads/presentation/views/LoadsDetails/AdditionalChargeLoadDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },

  {
    path: "/product-sale-charge/:code/:charge",
    name: "product-sale-details-charge",
    component: () =>
      import(
        "@/new_design/operations/loads/presentation/views/LoadsDetails/ProductSalesLoadDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },

  {
    path: "/product-sales/:id/:customer",
    name: "product-sales-details",
    component: () =>
      import(
        "@/new_design/manager/productSales/presentation/view/ProductSalesDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },

  {
    path: "/warehouse-part-only-adjustment/:idLocation/:idPart",
    name: "warehouse-part-adjustment-only-part",
    component: () =>
      import(
        "@/new_design/maintenance/warehouse/presentation/views/PartAdjustOnlyPartPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/warehouse-parts-only-part-redistribution/:idLocation/:idPart",
    name: "warehouse-parts-only-part-redistribution",
    component: () =>
      import(
        "@/new_design/maintenance/warehouse/presentation/views/PartRedistributionOnlyPartPage.vue"
      ),
    meta: { requiredAuth: true },
  },

  {
    path: "/rate/:rateId",
    name: "rate-details",
    component: () =>
      import(
        "@/new_design/manager/customer/presentation/view/RateDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },

  {
    path: "/rate-od/:rateId",
    name: "rate-od-details",
    component: () =>
      import(
        "@/new_design/manager/rates/presentation/components/views/RateDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/operation/vehicle/:vehicleId/:fleetType?",
    name: "vehicle-operation-details",
    component: () =>
      import(
        "@/new_design/operations/loads/presentation/views/VehicleDetails/VehicleDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
    props: true,
  },
  {
    path: "/load/:id/:fleetType/:currentPage",
    name: "load-details",
    component: () =>
      import(
        "@/new_design/operations/loads/presentation/views/LoadsDetails/LoadDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/load-review/:id/:fleetType/:currentPage",
    name: "load-review",
    component: () =>
      import(
        "@/new_design/operations/loads/presentation/views/LoadsDetails/LoadReviewPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/load/:id/history/:fleetType",
    name: "load-history-details",
    component: () =>
      import(
        "@/new_design/operations/loads/presentation/views/HistoryDetails/HistoryDetailsPage.vue"
      ),
    meta: { requiredAuth: true },
  },
  {
    path: "/inbox/:id/:fleetType/:currentPage",
    name: "inbox-details",
    component: () =>
      import(
        "@/new_design/operations/loads/presentation/components/Inbox/presentation/InboxDetails.vue"
      ),
    meta: { requiredAuth: true },
  },
];
